import React, { useState, useEffect } from 'react'
import { Box, Grid, Card, Flex, Text, Loader, Group, Switch, Badge, Button, ThemeIcon, NumberFormatter, Modal } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { updateOrder } from '../../../../services/orders'
import { getOrderDetail } from '../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../ui/Notifications'
import { calculation } from '../../../../services/calculation'
import { IconTax } from '@tabler/icons-react'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import FormAdjustCustomCharge from './Form/FormAdjustCustomCharge'

const OrderCustomCharges = () => {
  const { isLoadingOrder, summary, general, tax } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [loadingPayCustom, setLoadingPayCustom] = useState(false)
  const [payCustom, setPayCustom] = useState(false)
  const [loadingPayALI, setLoadingPayALI] = useState(false)
  const [payALI, setPayALI] = useState(false)
  const [openModalCustomCharge, setOpenModalCustomCharge] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleChangePayCustom = (val) => {
    setLoadingPayCustom(true)
    if (!val) {
      setLoadingPayALI(true)
    }
    handleChangeMethodPay('custom', val)
    
  }

  const handleChangePayALI = (val) => {
    setLoadingPayALI(true)
    handleChangeMethodPay('ali', val)
  }

  const handleChangeMethodPay = async (typePay, value) => {
    let payload = {}
    if (typePay === 'custom') {
      payload = {
        pay_custom: value
      }
      if (!value) {
        payload = {
          pay_custom: value,
          pay_via_ali: value
        }
      }
    } else {
      payload = {
        pay_via_ali: value
      }
    }
    
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        if (typePay === 'custom') {
          setPayCustom(value)
          if (!value) {
            setPayALI(value)
          }
        } else {
          setPayALI(value)
        }
        notificationSuccess('Update Order Successfully', 'This data has been updated')
        handleCalculation()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      if (typePay === 'custom') {
        setLoadingPayCustom(false)
        if (!value) {
          setLoadingPayALI(false)
        }
      } else {
        setLoadingPayALI(false)
      }
    }
  }

  const handleCalculation = async () => {
    const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
    const responseCalculation = await calculation(orderId)
    if (responseCalculation.success) {
      dispatch(getOrderDetail(orderId))
      completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
    }
  }

  useEffect(() => {
    if (!isLoadingOrder) {
      handleSetMethodPay(general)
    }
    // eslint-disable-next-line
  }, [general, isLoadingOrder])

  const handleSetMethodPay = (value) => {
    setPayCustom(value.payCustom)
    setPayALI(value.payViaAli)
  }

  const handleEditCustomCharge = (data) => {
    setDetailData(data)
    setOpenModalCustomCharge(true)
  }

  const onCloseModalCustomCharge = () => {
    setDetailData(null)
    setOpenModalCustomCharge(false)
  }

  const mappingFormPayCustom = () => {
    return (
      <Group align='center' gap='xs'>
        <Switch
          checked={payCustom}
          onChange={(event) => handleChangePayCustom(event.currentTarget.checked)}
          size='xs'
        />
        <Badge variant="light" color={payCustom ? 'teal' : 'red'} tt='capitalize' fw='500'>{payCustom ? 'Enabled' : 'Disabled'}</Badge>
      </Group>
    )
  }

  const mappingFormPayALI = () => {
    return (
      <Group align='center' gap='xs'>
        <Switch
          checked={payALI}
          size='xs'
          onChange={(event) => handleChangePayALI(event.currentTarget.checked)}
          disabled={!payCustom}
        />
        <Badge variant="light" color={payALI ? 'teal' : 'red'} tt='capitalize' fw='500'>{payALI ? 'Enabled' : 'Disabled'}</Badge>
      </Group>
    )
  }

  const handlingShowTotalCurrent = (type, valPayCustom, tax) => {
    let currentValue = 0
    let revisedValue = 0
    
    if (type === 'duty') {
      currentValue = tax.total_duty
      revisedValue = tax.revised_total_duty
    } else if (type === 'wht') {
      currentValue = tax.total_wht
      revisedValue = tax.revised_total_wht
    } else if (type === 'vat') {
      currentValue = tax.total_vat
      revisedValue = tax.revised_total_vat
    } else if (type === 'total') {
      currentValue = tax.total_custom_charges
      revisedValue = tax.revised_custom_charges
    }

    if (revisedValue > 0 && valPayCustom) {
      return (
        <Box className={revisedValue > 0 ? classes.PulseAnimation : ''}>
          <Text fz={14} td={revisedValue > 0 ? 'line-through' : ''} c={revisedValue > 0 ? 'red' : 'black'}>
            <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={currentValue} />
          </Text>
        </Box>
      )
    }
  }

  const handlingShowTotalRevised = (type, valPayCustom, tax) => {

    let currentValue = 0
    let revisedValue = 0
    let valuePayCustom = 0

    if (type === 'duty') {
      currentValue = tax.total_duty
      revisedValue = tax.revised_total_duty
    } else if (type === 'wht') {
      currentValue = tax.total_wht
      revisedValue = tax.revised_total_wht
    } else if (type === 'vat') {
      currentValue = tax.total_vat
      revisedValue = tax.revised_total_vat
    } else if (type === 'total') {
      currentValue = tax.total_custom_charges
      revisedValue = tax.revised_custom_charges
    }

    if (!valPayCustom) {
      valuePayCustom = currentValue
    } else {
      if (revisedValue > 0) {
        valuePayCustom = revisedValue
      } else {
        valuePayCustom = currentValue
      }
    }

    return (
      <Text fz={14} c='black'>
        <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={valuePayCustom} />
      </Text> 
    )
  }
  
  return (
    <Box>
      <Box my={20}>
        <Grid align='start' overflow='hidden'>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md' h={250}>
              <Card withBorder shadow="xs" radius="md" padding='md' mb='lg'>
                <Flex justify='space-between' align='center'>
                  <Text fz={12} fw='600'>Pay Custom</Text>
                  {!loadingPayCustom ? mappingFormPayCustom() : <Loader size='xs' />}
                </Flex>
              </Card>
              <Card withBorder shadow="xs" radius="md" padding='md'>
                <Flex justify='space-between' align='center'>
                  <Text fz={12} fw='600'>Pay Via ALI</Text>
                  {!loadingPayALI ? mappingFormPayALI() : <Loader size='xs' />}
                </Flex>
              </Card>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md' h={250}>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Text fz={16} fw={600}>Custom Charges (Tax)</Text>
                  <Button size='compact-xs' variant="outline" color='black' onClick={() => handleEditCustomCharge(tax)} disabled={!payCustom}>Edit</Button>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py='xs'>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconTax style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8' tt='capitalize'>Total BM / Duty</Text>
                  </Group>
                  <Group gap={!isLoadingOrder ? tax.revised_total_duty > 0 ? 4 : 2 : 0} align='center'>
                    {!isLoadingOrder ? 
                      handlingShowTotalCurrent('duty', payCustom, tax)
                      : 
                      ''
                    }
                    {!isLoadingOrder ? 
                      handlingShowTotalRevised('duty', payCustom, tax)
                      :
                      ''
                    }
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py='xs'>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconTax style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8' tt='capitalize'>Total PPH / WHT</Text>
                  </Group>
                  <Group gap={!isLoadingOrder ? tax.revised_total_wht ? 4 : 2 : 0} align='center'>
                    {!isLoadingOrder ? 
                      handlingShowTotalCurrent('wht', payCustom, tax)
                      : 
                      ''
                    }
                    {!isLoadingOrder ? 
                      handlingShowTotalRevised('wht', payCustom, tax)
                      :
                      ''
                    }
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py='xs'>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconTax style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8' tt='capitalize'>Total PPN / VAT</Text>
                  </Group>
                  <Group gap={!isLoadingOrder ? tax.revised_total_vat ? 4 : 2 : 0} align='center'>
                    {!isLoadingOrder ? 
                      handlingShowTotalCurrent('vat', payCustom, tax)
                      : 
                      ''
                    }
                    {!isLoadingOrder ? 
                      handlingShowTotalRevised('vat', payCustom, tax)
                      :
                      ''
                    }
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py='xs'>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <Text fz={14} fw={500} c='gray.7'>Total Customs Charges</Text>
                  </Group>
                  <Group gap={!isLoadingOrder ? tax.revised_custom_charges ? 4 : 2 : 0} align='center'>
                    {!isLoadingOrder ? 
                      // showTotalRevisedCustomCharges(tax.revised_custom_charges)
                      handlingShowTotalCurrent('total', payCustom, tax)
                      : 
                      ''
                    }
                    {!isLoadingOrder ? 
                      handlingShowTotalRevised('total', payCustom, tax)
                      // <Text fz={16} fw='600' c='blue'>
                      //   <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={tax.revised_custom_charges} />
                      // </Text> 
                      :
                      ''
                    }
                  </Group>
                </Flex>
              </Card.Section>
            </Card>
          </Grid.Col>
        </Grid>
        <Box mt={24}>
          <Text fz={12} mb={4} c='red'>** If you disable Pay Custom then Pay via ALI will automatically be disabled</Text>
          <Text fz={12} mb={4} c='violet.9'>** Grand total of "Total Logistic Charge" and "Total Customs Charges" will be "Total Logistic All In"</Text>
        </Box>
      </Box>
      <Modal opened={openModalCustomCharge} onClose={onCloseModalCustomCharge} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Edit Total Custom Charges (Tax)</Text>} withCloseButton={false}>
        <FormAdjustCustomCharge dataCharges={detailData} onCloseForm={onCloseModalCustomCharge} />
      </Modal>
    </Box>
  )
}

export default OrderCustomCharges